import SideMenu from '@/containers/side-menu/SideMenu.vue';
import SettledCredits from '@/pages/reports/settled-credits/SettledCredits.vue';

export default {
  path: '/reports/settled-credits',
  name: 'SettledCredits',
  components: {
    mainContent: SettledCredits,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'report-settled-credits',
    },
    breadcrumb: {
      title: 'Relatório de Créditos Quitados',
      paths: [{ title: 'Relatórios' }, { title: 'Créditos quitados' }],
    },
  },
};
